import request from '@/utils/request'

export const checkCustomerName = params =>
  request.post('/customer-api/customer/check', params)
